export enum IUserRole {
    ORG_USER = 'ORG_USER',
    ORG_PRIMARY = 'ORG_PRIMARY',
    CIC_USER = 'CIC_USER',
    CIC_ADMIN = 'CIC_ADMIN',
    CIC_OWNER = 'CIC_OWNER'
}
